import Observable from 'zen-observable'
import { Vue, Component } from 'vue-property-decorator'
import { API, graphqlOperation } from 'aws-amplify'
import { GraphQLResult } from '@aws-amplify/api/lib/types'

interface Subscription {
	data: Promise<any[]>
	subscription: { unsubscribe: () => void }
}

export interface IDb {
	query(query: string, variables?: any): Promise<any>
	subscribe: (query: string, type: string, fields: string, component: any, key: string) => Subscription
}

@Component
class DbService extends Vue implements IDb {

	async query(query: string, variables?: any): Promise<any> {
		let res: GraphQLResult = {}
		try {
			res = await API.graphql({ query, variables }) as GraphQLResult
		} catch(err) {
			const message = err.message || err.errors[0].message
			throw new Error(message)
		}
		return res.data
	}

	subscribe(query: string, type: string, fields: string, component: any, key: string) {

		// subscribe to CUD
		const subscription = (API.graphql(graphqlOperation(`
		subscription On${type}Change {
			onCreate${type} { ${fields}	}
			onUpdate${type} { ${fields} }
			onDelete${type} { ${fields} }
		  }
		`)) as Observable<any>).subscribe({
			next: eventData => {
				// mutate array depending on operation
				if(eventData.value.data[`onCreate${type}`]) {
					let created = eventData.value.data[`onCreate${type}`]
					if(!Array.isArray(created)) {
						created = [created]
					}
					created.forEach(c => {
						if(!component[key].find(item => item.id === c.id)) {
							component[key].push(c)
						}
					})
				}
				if(eventData.value.data[`onUpdate${type}`]) {
					const updatedItem = eventData.value.data[`onUpdate${type}`]
					const index = component[key].findIndex(item => item.id === updatedItem.id)
					if(index === -1) {
						component[key].push(updatedItem)
					} else {
						component[key][index] = updatedItem
					}
				}
				if(eventData.value.data[`onDelete${type}`]) {
					const deletedId = eventData.value.data[`onDelete${type}`].id
					const index = component[key].findIndex(item => item.id === deletedId)
					if(index !== -1) {
						component[key].splice(index, 1)
					}
				}
				// reassign data property to a copy of itself so Vue notices
				component[key] = [...component[key]]
			}
		})

		// get all items
		const data = (API.graphql(graphqlOperation(`
			query List${type}s {
				${query} { ${fields} }
			}
		`)) as Promise<GraphQLResult>).then(listData => listData.data ? listData.data[query] : {})

		return {
			data,
			subscription
		}
	}

}

export const $db: IDb = new DbService()
